import type { FC, PropsWithChildren } from 'react';

import {
    AiAltDealStructureOpenStateProvider,
    AiAltDealStructureProvider,
    AltDealStructureGridContainer
} from './AiAltDealStructureSlideout';

export const AltDealStructureProviders: FC<PropsWithChildren> = ({ children }) => (
    <AiAltDealStructureOpenStateProvider>
        <AltDealStructureGridContainer>
            <AiAltDealStructureProvider>{children}</AiAltDealStructureProvider>
        </AltDealStructureGridContainer>
    </AiAltDealStructureOpenStateProvider>
);
